import React from "react";
import { Link } from "react-router-dom";
import { 
  Calendar, User, Tag, ChevronRight, Search, Newspaper, TrendingUp, Clock 
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { LINKS } from "@/data/site";

//[cite: 2] 关键：导出数据供 NewsDetail 使用
export const NEWS_POSTS = [
  {
    id: 1,
    title: "How to Win Big on JILI Super Ace: The Ultimate Guide 2026",
    excerpt: "Master the patterns of JILI's top game. Learn when to increase your bet and how the RTP affects your session at U2.",
    category: "Slot Tips",
    author: "U2 Expert",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1517232115160-ff93364542dd?q=80&w=2146&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", 
  },
  {
    id: 2,
    title: "Top 10 Trusted Online Casinos in Malaysia: Why U2 Ranks #1",
    excerpt: "We compare security, withdrawal speed, and game variety. Discover why U2 is the preferred choice for players.",
    category: "Reviews",
    author: "Admin",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1606167668584-78701c57f13d?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 3,
    title: "Instant DuitNow Transfers: Seamless Gaming Experience at U2",
    excerpt: "Say goodbye to long wait times. U2's new DuitNow integration allows for 3-minute deposits and instant withdrawals.",
    category: "Guide",
    author: "FinTech Team",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 4,
    title: "PG Soft Mahjong Ways 2: Best Strategy to Win Big 2026",
    excerpt: "Unlock the golden reels! Learn the professional betting patterns for PG Soft Mahjong Ways 2 and increase your chances.",
    category: "Slot Tips",
    author: "U2 Expert",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 5,
    title: "Is U2 Casino Safe? 2026 Security & Licensing Review",
    excerpt: "Deep dive into U2's encryption and PAGCOR compliance. See how we protect your data and ensure fair results.",
    category: "Safety",
    author: "Security Officer",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 6,
    title: "Top 5 High RTP Slots to Play in Malaysia This Week (97.5%+)",
    excerpt: "Don't waste money! We list this week's highest RTP slots available exclusively on the U2 platform for better odds.",
    category: "New Games",
    author: "Game Critic",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1518623489648-a173ef7824f3?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 7,
    title: "How to Claim 100% Welcome Bonus at U2 Casino: Guide",
    excerpt: "New to U2? Follow our step-by-step guide to claim your 100% bonus and maximize your starting credit today.",
    category: "Guide",
    author: "Promo Team",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 8,
    title: "Download U2 App: The Best Mobile Slot Experience in 2026",
    excerpt: "Play on the go! Download the U2 app for iOS and Android. High-speed gaming and secure login at your fingertips.",
    category: "Tech",
    author: "Tech Support",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 9,
    title: "USDT Deposits at U2: The Future of Crypto Gaming in Malaysia",
    excerpt: "Explore the benefits of crypto. Learn about U2's support for USDT and how it ensures faster, private payments.",
    category: "Trends",
    author: "U2 Founder",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?auto=format&fit=crop&q=80&w=800",
  },
  {
    id: 10,
    title: "Responsible Gambling: Setting Limits for a Smart Play",
    excerpt: "Play smart and stay safe. Learn how to use U2's built-in tools to manage your gaming time and budget effectively.",
    category: "Safety",
    author: "Care Team",
    date: "May 06, 2026",
    image: "https://images.unsplash.com/photo-1553729459-efe14ef6055d?auto=format&fit=crop&q=80&w=800",
  }
];

export default function U2News() {
  return (
    <div className="bg-[#07070a] min-h-screen text-zinc-100 pb-20">
      <section className="relative pt-28 pb-16 border-b border-orange-500/10 bg-gradient-to-b from-[#0f0a05] to-[#07070a]">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div className="max-w-2xl">
              <h1 className="font-display text-4xl md:text-6xl tracking-wider text-zinc-50">
                U2 <span className="text-orange-grad">NEWS & TIPS</span>
              </h1>
              <p className="mt-4 text-zinc-400 text-lg">Latest <strong>Online Casino Malaysia</strong> trends and strategies.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-10">
            {NEWS_POSTS.map((post) => (
              <article key={post.id} className="group grid md:grid-cols-5 gap-6 items-start">
                <div className="md:col-span-2 overflow-hidden rounded-2xl aspect-video border border-zinc-800">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-all" />
                </div>
                <div className="md:col-span-3">
                  <h2 className="text-2xl font-display text-zinc-100 group-hover:text-orange-300">
                    <Link to={`/news/${post.id}`}>{post.title}</Link>
                  </h2>
                  <p className="mt-3 text-zinc-400 text-sm line-clamp-2">{post.excerpt}</p>
                  <Link to={`/news/${post.id}`} className="mt-4 inline-flex items-center gap-1 text-xs font-bold text-orange-500 uppercase">
                    Read Full Article <ChevronRight className="w-3 h-3" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
